import { render } from "./OrganisationList.vue?vue&type=template&id=033defd7"
import script from "./OrganisationList.vue?vue&type=script&lang=js"
export * from "./OrganisationList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__